module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-google-tagmanager/gatsby-browser.js'),
      options: {"plugins":[],"id":"GTM-533W5895","includeInDevelopment":false,"enableWebVitalsTracking":true,"selfHostedOrigin":"https://estagionpj.com","selfHostedPath":"metrics","defaultDataLayer":null,"routeChangeEventName":"gatsby-route-change"},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"EstagioNPJ.com","short_name":"EstagioNPJ.com","description":"EstagioNPJ: Peças processuais no rigor técnico exigido pelos orientadores do Núcleo de Prática Jurídica (NPJ). Fundamentação doutrinária e jurisprudencial sólida.","start_url":"/","background_color":"#fff","display":"standalone","icon":"static/sites/estagionpj/favicon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"c4a56ae3ca39144bdeaf504792e5f054"},
    },{
      plugin: require('../node_modules/gatsby-plugin-next-seo/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../gatsby-browser.ts'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
